import { HelpLoader } from '@enkla-gui'
import React from 'react'

export default function Help({ children, title = 'Information', type = 'warning', icon = 'fas fa-lightbulb', header = true, temporary = false, loading = false }) {
	return (
		<div className='component_Help'>
			<div className={`help-container help-${type} ${temporary ? 'temporary' : ''} ${!header || !title ? 'no-title' : ''}`}>
				{icon && (
					<div className='help-icon-wrapper'>
						<i className={icon} />
					</div>
				)}
				<div className='help-content'>
					{loading && <HelpLoader />}
					{!loading && (
						<>
							{header && title && <div className='help-title'>{title}</div>}
							<div className='help-body'>{children}</div>
						</>
					)}
				</div>
			</div>
		</div>
	)
}
